import React, { PropTypes } from 'react';
import moment from 'moment';

import { AVAILABLE } from '../EventHeader/BookNow/helpers/availabilityTypes';

import {
  date,
  distance,
  discount as discountStyle,
  footer,
  info,
  pricing,
  summary,
  title as titleStyle,
  unavailablePricing,
} from './styles.module.css';

const formatStartDate = (startDate, startTime) => startTime
  ? moment.utc(startDate).format('h:mma ddd Do MMM YYYY')
  : moment.utc(startDate).format('ddd Do MMM YYYY');

/**
 * Race summary presentational component.
 */
const RaceSummary = ({
  availability, availabilityLabel, discount, distanceLabel,
  priceLabel, startDate, startTime, title,
}) => (
  <article className={summary}>
    <header>
      <h3 className={titleStyle}>{title}</h3>
    </header>
    <div className={info}>
      <div>
        <div className={distance}>{distanceLabel}</div>
        <date className={date} dateTime={startDate}>{formatStartDate(startDate, startTime)}</date>
      </div>
      {discount && <div className={discountStyle}>{discount}</div>}
    </div>
    {(priceLabel || availabilityLabel) && (
      <footer className={footer}>
        {priceLabel && (
          <div className={availability !== AVAILABLE ? unavailablePricing : pricing}>
            {priceLabel}
          </div>
        )}
        {availabilityLabel && <div className={pricing}>{availabilityLabel}</div>}
      </footer>
    )}
  </article>
);

RaceSummary.propTypes = {
  availability: PropTypes.string.isRequired,
  availabilityLabel: PropTypes.string.isRequired,
  discount: PropTypes.string,
  distanceLabel: PropTypes.string.isRequired,
  priceLabel: PropTypes.string,
  startDate: PropTypes.string.isRequired,
  startTime: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

RaceSummary.defaultProps = {
  discount: undefined,
  priceLabel: undefined,
  startTime: false,
};

export default RaceSummary;



// WEBPACK FOOTER //
// ./app/src/components/RaceSummary/component.jsx